import { useMemo, useReducer } from 'react'
import PropTypes from 'prop-types'

import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_INCORRECT_PASSWORD,
} from '../../auth/cognito/statuses'

import { useAuthContext } from '../../auth/AuthProvider'
import { useUserContext } from '../../auth/UserProvider'

import ContactDataEditorView from './ContactDataEditor/View'
import PasswordEditorView from './PasswordEditor/View'

import UserZoneView from './View'

export const profileFormPropTypes = {
  contactPerson: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  currentPassword: PropTypes.string,
  newPassword: PropTypes.string,
  confirmNewPassword: PropTypes.string,
}

const UserZone = () => {
  const { changePassword } = useAuthContext()
  const { webUserName, webUserEmail, centres } = useUserContext()

  const values = useMemo(
    () => ({
      contactPerson: webUserName ?? '',
      email: webUserEmail ?? '',
      phone: '',
    }),
    [webUserEmail, webUserName],
  )

  const [passwordChangeState, passwordChangeDispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'begin': {
          return {
            success: false,
            badCurrentPassword: false,
            unknownError: false,
          }
        }
        case 'success': {
          return {
            success: true,
            badCurrentPassword: false,
            unknownError: false,
          }
        }
        case 'error': {
          const error = action.payload
          return {
            success: false,
            badCurrentPassword:
              error.status === CHANGE_PASSWORD_INCORRECT_PASSWORD,
            unknownError: error.status === CHANGE_PASSWORD_FAILURE,
          }
        }
        default: {
          console.error('Unknown action type -- Programing error?', action)
          return {
            success: false,
            badCurrentPassword: false,
            unknownError: true,
          }
        }
      }
    },
    {
      success: false,
      error: null,
    },
  )
  const updatePassword = async ({
    currentPassword,
    newPassword,
    confirmNewPassword,
  }) =>
    new Promise((resolve, reject) => {
      if (newPassword !== confirmNewPassword) {
        reject()
      } else {
        resolve({ currentPassword, newPassword })
      }
    })
      .then(({ currentPassword, newPassword }) => {
        passwordChangeDispatch({ type: 'begin' })
        return changePassword(currentPassword, newPassword)
      })
      .then(() => {
        passwordChangeDispatch({ type: 'success' })
      })
      .catch(reason => {
        passwordChangeDispatch({ type: 'error', payload: reason })
      })

  return (
    <UserZoneView
      username={webUserName}
      centres={centres?.map(({ id, name }) => ({
        clientCode: id,
        clientName: name,
      }))}
      contactDataSlot={
        <ContactDataEditorView
          contactValues={values}
          updateContactData={values => {
            console.debug(values)
          }}
        />
      }
      passwordSlot={
        <PasswordEditorView
          hasBadCurrentPassword={passwordChangeState.badCurrentPassword}
          updatePassword={updatePassword}
          hasSucceeded={passwordChangeState.success}
          hasFailed={passwordChangeState.unknownError}
        />
      }
    />
  )
}

export default UserZone
